import React from 'react';

import { cssMap } from '@compiled/react';
import { defineMessages, useIntl } from 'react-intl-next';

import Image from '@atlaskit/image';
import { Box, Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import GesturalLinesDark from './assets/gestural-lines/dark.svg';
import GesturalLinesLight from './assets/gestural-lines/light.svg';
import SearchNoResultsDark from './assets/search-no-results/dark.svg';
import SearchNoResultsLight from './assets/search-no-results/light.svg';

export const i18n = defineMessages({
	aiActionsSectionText: {
		id: 'ai-smart-button.ai-actions.actions.section.text',
		defaultMessage: 'Actions',
		description: 'The section text for the AI Actions in a Menu Group',
	},
	aiStudioSectionText: {
		id: 'ai-smart-button.ai-actions.rovo-agents.section.text',
		defaultMessage: 'Studio',
		description:
			'The section text for the AI Studio section (containing rovo agents) in a Menu Group',
	},
	noResultsHeading: {
		id: 'ai-smart-button.ai-actions.no-results-heading',
		defaultMessage: 'Ask Rovo',
		description: 'Heading when there are no actions for what the user has queried.',
	},
	noResultsText: {
		id: 'ai-smart-button.ai-actions.no-results-text',
		defaultMessage: 'Send your prompt to Rovo to start a chat.',
		description:
			'Description when there are no actions for what the user has queried. The description should prompt the user to send a chat query to Rovo.',
	},
});

const styles = cssMap({
	imageContainer: {
		maxWidth: '124px',
	},
	gesturalLinesContainer: {
		position: 'relative',
	},
	gesturalLines: {
		position: 'absolute',
		maxWidth: '24px',
		top: token('space.0'),
		left: token('space.0'),
		transform: 'translate(-100%,-50%)',
	},
	heading: {
		font: token('font.heading.medium'),
		fontWeight: token('font.weight.medium'),
	},
});

export function NoResults(): React.JSX.Element {
	const intl = useIntl();

	return (
		<Stack alignInline="center" grow="fill">
			<Stack space="space.200" alignInline="center">
				<Box xcss={styles.imageContainer}>
					{/* eslint-disable-next-line @atlassian/a11y/alt-text -- See https://go/a11y-alt-text for more details */}
					<Image src={SearchNoResultsLight} srcDark={SearchNoResultsDark} />
				</Box>
				<Box xcss={styles.gesturalLinesContainer}>
					<Box xcss={styles.gesturalLines}>
						{/* eslint-disable-next-line @atlassian/a11y/alt-text -- See https://go/a11y-alt-text for more details */}
						<Image src={GesturalLinesLight} srcDark={GesturalLinesDark} />
					</Box>
					<Box xcss={styles.heading}>{intl.formatMessage(i18n.noResultsHeading)}</Box>
				</Box>
				<Text size="medium" color="color.text.subtle" align="center">
					{intl.formatMessage(i18n.noResultsText)}
				</Text>
			</Stack>
		</Stack>
	);
}
